import { outlinedPickerFieldSx } from 'lib/form-field-styles'

const PICKER_FIELD_HEIGHT = 56
const PICKER_ICON_COLOR = '#172024'

// Shared by the schedule picker and the lesson date filter so both match the
// 56px outlined fields around them.
export const pickerTextField = {
  variant: 'outlined',
  fullWidth: true,
  sx: {
    ...outlinedPickerFieldSx,
    '& .MuiOutlinedInput-root': {
      ...outlinedPickerFieldSx['& .MuiOutlinedInput-root'],
      height: PICKER_FIELD_HEIGHT,
    },
  },
}

export const pickerIconButton = { sx: { color: PICKER_ICON_COLOR } }
